import { render, staticRenderFns } from "./TabOnglet.vue?vue&type=template&id=bf81b24e"
import script from "./TabOnglet.vue?vue&type=script&lang=js"
export * from "./TabOnglet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports